// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActivityStatusController from "./activity_status_controller"
application.register("activity-status", ActivityStatusController)

import Admin__NotificationBadgeController from "./admin/notification_badge_controller"
application.register("admin--notification-badge", Admin__NotificationBadgeController)

import Admin__NotificationItemController from "./admin/notification_item_controller"
application.register("admin--notification-item", Admin__NotificationItemController)

import ChecklistController from "./checklist_controller"
application.register("checklist", ChecklistController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ContentToggleController from "./content_toggle_controller"
application.register("content-toggle", ContentToggleController)

import CopySummaryController from "./copy_summary_controller"
application.register("copy-summary", CopySummaryController)

import DashboardController from "./dashboard_controller"
application.register("dashboard", DashboardController)

import FormResetController from "./form_reset_controller"
application.register("form-reset", FormResetController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import IdeaFormController from "./idea_form_controller"
application.register("idea-form", IdeaFormController)

import ImageCropController from "./image_crop_controller"
application.register("image-crop", ImageCropController)

import MarkdownRendererController from "./markdown_renderer_controller"
application.register("markdown-renderer", MarkdownRendererController)

import MobileDrawerController from "./mobile_drawer_controller"
application.register("mobile-drawer", MobileDrawerController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import SidebarChatsController from "./sidebar_chats_controller"
application.register("sidebar-chats", SidebarChatsController)

import TextareaAutogrowController from "./textarea_autogrow_controller"
application.register("textarea-autogrow", TextareaAutogrowController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import TitleEditController from "./title_edit_controller"
application.register("title-edit", TitleEditController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import UsageLimitController from "./usage_limit_controller"
application.register("usage-limit", UsageLimitController)

import UserStatusController from "./user_status_controller"
application.register("user-status", UserStatusController)
